import { Component, Input, OnInit } from '@angular/core';
import { TonsPerYardService } from 'src/app/_services/tons-per-yard/tons-per-yard.service';
import { TonsPerYard } from 'src/app/interfaces/tons-per-yard.interfaces';

/**
 * Componente que muestra, mediante un overlay, el listado de tonelaje y piezas
 * almacenadas por ubicación (patio) para un lote y módulo determinados, junto
 * con sus totales.
 */
@Component({
  selector: 'app-tons-per-yard',
  templateUrl: './tons-per-yard.component.html',
  styleUrls: ['./tons-per-yard.component.css']
})
export class TonsPerYardComponent implements OnInit {
  @Input() batchId: number = 0;
  @Input() module: number = 0;
  amountsPerYardList: TonsPerYard[] = [];
  totalTons: number = 0;
  totalPieces: number = 0;
  tonsPerYardOverlay: boolean = false;
  loading: boolean = false;
  overlayError: boolean = false;

  constructor(
    private _TonsPerYardSvc: TonsPerYardService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Alterna la visibilidad del overlay y, al abrirlo, solicita el listado de tonelaje por patio.
   */
  togleTonsPerYardOverlay(): void {
    this.tonsPerYardOverlay = !this.tonsPerYardOverlay;
    if (this.tonsPerYardOverlay) this.getTonsPerYardList();
  }

  /**
   * Consulta el listado de tonelaje y piezas por patio del módulo y lote actuales y calcula sus totales.
   */
  getTonsPerYardList(): void {
    this.loading = true;
    this._TonsPerYardSvc.getTonsPerYardList(this.module, this.batchId)
    .subscribe({
      next: ( amountsPerYardList ) => {
        this.loading = false;
        this.amountsPerYardList = [...amountsPerYardList];
        this.totalTons = this.amountsPerYardList.reduce((totalTons, amount) => amount.tonnage + totalTons, 0);
        this.totalPieces = this.amountsPerYardList.reduce((totalPieces, amount) => amount.pieces + totalPieces, 0);
      }, error: () => {
        this.loading = false;
        this.overlayError = true;
      }
    });
  }
}
